import { Save } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import API from "../../../services/API";
import { useContext, useState } from "react";
import ToastContext from "../../../services/Context/ToastContext";
import Wysiwyg from "../../Inputs/Wysiwyg";
import { LoadingButton } from "@mui/lab";
import { txt } from "../../../services/translation";

export default function CourseDescription({course, onChange}){

    const {setToast} = useContext(ToastContext)

    const [value, setValue] = useState(course.description || '')

    const [status, setStatus] = useState('ready')

    const handleSubmit = e => {

        e.preventDefault();

        setStatus('submit')

        API.put(`/design/courses/${course.id}`, {...course, description: value})
            .then(r => {

                onChange(r.data)

                setToast({
                    severity: 'success',
                    message: txt('changesSavedSuccess')
                })

            })
            .catch(_ => {

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })

            })
            .finally(() => setStatus('ready'))
    }


    const handleChange = html => {
        setValue(html)
        setStatus('changed')
    }


    return <form onSubmit={handleSubmit}>

        <Stack>

            <Stack direction='row' justifyContent='space-between' alignItems='center'>

                <Typography color='text.secondary'>Présentation de l'événement</Typography>

                {['changed','submit'].includes(status) &&

                    <LoadingButton 
                        type='submit'
                        loading={status === 'submit'}
                    >
                        <Save />
                    </LoadingButton>
                }

            </Stack>

            <Wysiwyg 
                value={value}
                onChange={handleChange}
                onImageUpload={file => API.upload('/pictures', file)
                    .catch(_ => setToast({
                        severity: 'error',
                        message: "Image trop lourde ou format incorrect"
                    }))
                }
            />

        </Stack>

    </form>
}